<span class="tag-text"
    *ngIf="companyName.length">
    Company Name
</span>
<ng-container *ngFor="let item of companyName; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
    <i class="fal fa-times"
        stopPropagation
        (click)="triggerChange('companyName', item)"></i>
</span>
</ng-container>

<span class="tag-text"
      *ngIf="industry.length">
    Industry
</span>
<ng-container *ngFor="let item of industry; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
  <i class="fal fa-times"
     stopPropagation
     (click)="triggerChange('industry', item)"></i>
</span>
</ng-container>


<span class="tag-text"
    *ngIf="employeeRange.length">
    Employes
</span>
<ng-container *ngFor="let item of employeeRange; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
    <i class="fal fa-times"
        stopPropagation
        (click)="triggerChange('employeeRange', item)"></i>
</span>
</ng-container>


<span class="tag-text"
    *ngIf="revenueRange.length">
    Revenue
</span>
<ng-container  *ngFor="let item of revenueRange; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
    <i class="fal fa-times"
        stopPropagation
        (click)="triggerChange('revenueRange', item)"></i>
</span>
</ng-container>

<span class="tag-text"
    *ngIf="ownership.length">
    Ownership
</span>
<ng-container *ngFor="let item of ownership; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
    <i class="fal fa-times"
        stopPropagation
        (click)="triggerChange('ownership', item)"></i>
</span>
</ng-container>

<span class="tag-text"
    *ngIf="location.length">
    Located
</span>
<ng-container *ngFor="let item of location; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
    <i class="fal fa-times"
        stopPropagation
        (click)="triggerChange('location', item)"></i>
</span>
</ng-container>

<span class="tag-text"
      *ngIf="country.length">
    Country
</span>

<ng-container *ngFor="let item of country; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
  <i class="fal fa-times"
     stopPropagation
     (click)="triggerChange('country', item)"></i>
</span>
</ng-container>


<span class="tag-text"
      *ngIf="website.length">
    Website
</span>
<ng-container  *ngFor="let item of website; index as i">
  <span class="tag-item" *ngIf="i < 5">
    {{ item }}
  <i class="fal fa-times"
     stopPropagation
     (click)="triggerChange('website', item)"></i>
</span>

</ng-container>
<span *ngIf="website.length > 0 || country.length > 0 || location.length > 0 || ownership.length > 0 ||
   revenueRange.length > 0 || employeeRange.length > 0 || industry.length > 0 || companyName.length > 0"
  class="tag-item"
  stopPropagation
  style="cursor: pointer;"
  (click)="showWebsitesList()">
<i class="fal fa-ellipsis-h" stopPropagation (click)="showWebsitesList()"></i>
</span>

